import { standardHandlerClass } from 'j/main/lib/tools/init'

const PHONEMAX = 667

// Add class '.parallax' to image base_classes to enable,
// Add '.mobile-parallax' to enable on mobile

class ParallaxClass {
  constructor(el, conf = {}) {
    this.el = el
    this.offset = parseFloat(this.el.dataset.offset) || 0.25
    this.originalPadding = this.el.closest(
      '.aspect-maintainer'
    ).style.paddingTop
  }

  init() {
    if (
      window.innerWidth > PHONEMAX ||
      this.el.classList.contains('mobile-parallax')
    ) {
      this.resizeHandler()
    }
  }

  scrollHandler(scrollY, scrollX) {
    if (
      window.innerWidth > PHONEMAX ||
      this.el.classList.contains('mobile-parallax')
    ) {
      this.el.style.transform = `translate3d(0, ${this.el.getBoundingClientRect()
        .top *
        this.offset *
        -1}px, 0)`
    }
  }

  resizeHandler() {
    if (
      window.innerWidth > PHONEMAX ||
      this.el.classList.contains('mobile-parallax')
    ) {
      this.originalPadding = `${this.el.getAttribute('height') / this.el.getAttribute('width') * 100}%`
      this.el.closest('.aspect-maintainer').removeAttribute('style')
      this.el.closest(
        '.aspect-maintainer'
      ).style.paddingTop = this.originalPadding


      const paddingTop = parseInt(
        window.getComputedStyle(this.el.closest('.aspect-maintainer'))
          .paddingTop
      )

      const width = this.el.closest('.aspect-maintainer').getBoundingClientRect().width
      const aspectRatio =
        ((paddingTop - paddingTop * (this.offset / 2)) / width) * 100

      this.el.closest('.aspect-maintainer').style.paddingTop = `${aspectRatio}%`
      this.el.style.height = 'auto'
      this.el.style.transform = `translate3d(0, ${this.el.getBoundingClientRect()
        .top *
        this.offset *
        -1}px, 0)`
    } else {
      this.el.style.transform = `translate3d(0, 0, 0)`
      this.el.closest(
        '.aspect-maintainer'
      ).style.paddingTop = this.originalPadding
      this.el.style.height = 'auto'
    }
  }
}

const Parallax = standardHandlerClass(ParallaxClass)
export default Parallax
